<script lang="ts">
    import { DropdownItem } from '@components/ui/dropdown';

    import s from './dropdown-item.module.css';
    export let onClick: (() => void) | null = null;
    export let testId: string | null = null;
</script>
<DropdownItem classes={s.dropdownItem} on:click={onClick} testId={testId}>
    <slot />
</DropdownItem>